import Vue from 'vue'
import axios from 'axios'
//import Vuetify from 'vuetify';
window.Vue = Vue;

Vue.component('downloader', require('./components/Downloader.vue').default);
//Vue.use(Vuetify);
const app = new Vue({
    el: '#downloader',
    //vuetify : new Vuetify()
});
